import React, {Component} from 'react'

import {connect} from 'react-redux'
import {createStructuredSelector} from "reselect"
import styled from 'styled-components'
import OpCheckbox from "common/views/components/OpCheckbox"
import {selectIsTitlePlaceOrderNowAnsweredYes, selectTitleWhoIsProviderName} from "manager/selectors/referral_selectors"
import AuthorizeQualiaLegalese from "manager/views/components/ReferralStatus/Common/AuthorizeQualiaLegalese"
import {ANSWER_TYPE, QUESTION_TYPE} from "common/constants"
import {updateAgentTitleQuestions} from "manager/redux/referral"

const PlaceOrderResponse = styled.div`
  border-radius: 5px;
  padding: 11px 10px;
  display: flex;
  background-color: ${props => props.terms_accepted ? '#0588DD' : '#F1F1F4'};
`

const TermsDescription = styled.div`
  font-size: 12px;
  line-height: 21px;
  letter-spacing: 0;
  
  color: ${props => props.terms_accepted ? '#FFFFFF' : '#4A4A4A'};
  
  .yes {
    font-weight: bold;
  }
  
  a, a:hover, a:focus, a:visited {
    color: ${props => props.terms_accepted ? '#FFFFFF' : '#0588DD'};
    text-decoration: underline;
    font-weight: bold;
  }
`

const FullTermsSection = styled.div`
  display: flex;
  flex-direction: column;
`

class ReferralQuestionTitlePlaceOrderNow extends Component {

  state = {
    show_full_terms_description: false
  }

  async componentDidMount() {
    const {updateAgentTitleQuestions} = this.props
    await updateAgentTitleQuestions({[QUESTION_TYPE.TITLE_PLACE_ORDER_NOW]: {[ANSWER_TYPE.YES_NO]: "no"}})
  }

  toggleAcceptTerms = () => {
    const {updateAgentTitleQuestions, isTitlePlaceOrderNowAnsweredYes} = this.props
    const newAnswer = (isTitlePlaceOrderNowAnsweredYes) ? 'no' : 'yes'
    updateAgentTitleQuestions({[QUESTION_TYPE.TITLE_PLACE_ORDER_NOW]: {[ANSWER_TYPE.YES_NO]: newAnswer}})
  }

  render() {

    const { isTitlePlaceOrderNowAnsweredYes, titleWhoIsProviderName } = this.props

    const { show_full_terms_description } = this.state

    return (
      <div className="ReferralQuestion">
        <div className="question">Would you like to place an order now?</div>
        <div className="question-sub">Optional</div>
        <PlaceOrderResponse terms_accepted={isTitlePlaceOrderNowAnsweredYes}>
          <OpCheckbox checked={isTitlePlaceOrderNowAnsweredYes} onChange={this.toggleAcceptTerms}/>
          <TermsDescription terms_accepted={isTitlePlaceOrderNowAnsweredYes}>
            <span className={'yes'}>Yes,&nbsp;</span>
            <span>send the provided information on behalf of of my client to {titleWhoIsProviderName}.</span>
            { show_full_terms_description
              ? ( <FullTermsSection>
                    <AuthorizeQualiaLegalese/>
                    <a onClick={() => this.setState({show_full_terms_description: false})}>See less</a>
                  </FullTermsSection>
              ) : (
                <span>&nbsp;<a onClick={() => this.setState({show_full_terms_description: true})}>See more</a></span>
              )
            }
          </TermsDescription>
        </PlaceOrderResponse>
      </div>
    )
  }
}

const selector = createStructuredSelector({
  titleWhoIsProviderName: selectTitleWhoIsProviderName,
  isTitlePlaceOrderNowAnsweredYes: selectIsTitlePlaceOrderNowAnsweredYes
})

const actions = {
  updateAgentTitleQuestions
}

export default connect(selector, actions)(ReferralQuestionTitlePlaceOrderNow)
